import { Matrix4 } from 'three';
import {ObjectTypes} from '@data/models';

export const computeVersionedTransform = (
  objectTransform: number[],
  gingivaTransform: number[],
  formatVersion: number
): number[] => {
  if (formatVersion >= 2) {
    const gingivaMatrix = new Matrix4();
    gingivaMatrix.fromArray(gingivaTransform);
    const objectMatrix = new Matrix4();
    objectMatrix.fromArray(objectTransform, 0);
    objectMatrix.multiply(gingivaMatrix);
    return objectMatrix.toArray();
  }
  return objectTransform;
};

export const getDisplacedTransform = (
  objectDescription: any,
  displacementMatrix: Matrix4,
  formatVersion?: number,
  gingivaTransform?: number[] | null
): number[] | null => {
  if (formatVersion && formatVersion >= 2) {
    if (objectDescription.transform && gingivaTransform) {
      const gingivaMatrix = new Matrix4().fromArray(gingivaTransform);
      const gingivaInverse = gingivaMatrix.clone().invert();
      const initialTransformMatrix = new Matrix4();
      initialTransformMatrix.fromArray(objectDescription.transform, 0);
      initialTransformMatrix
        .multiply(gingivaInverse)
        .multiply(displacementMatrix)
        .multiply(gingivaMatrix);
      return initialTransformMatrix.toArray();
    }
  }
  // legacy
  switch (objectDescription.type) {
    case ObjectTypes.Gingiva:
    case ObjectTypes.Elastic:
    case ObjectTypes.CbctJaw:
      return displacementMatrix.toArray();
    default:
      if (objectDescription.transform) {
        const initialTransformMatrix = new Matrix4();
        initialTransformMatrix.fromArray(objectDescription.transform, 0);
        initialTransformMatrix.multiply(displacementMatrix);
        return initialTransformMatrix.toArray();
      }
  }

  return null;
}

